import { Field } from 'Util/Query';

export class SearchQuery {
    getQuery(options) {
        this.options = options;
        const { search } = options;

        return new Field('search')
            .addArgument('search', 'String!', encodeURIComponent(search))
            .addFieldList(this._getSearchFields());
    }

    _getSearchFields() {
        return [
            this._getSearchProductsField(),
            this._getSearchCategoriesField(),
            this._getSearchPagesField()
        ];
    }

    // Products

    _getSearchProductsField() {
        return new Field('products')
            .addFieldList(this._getSearchProductsFields());
    }

    _getSearchProductsFields() {
        return [
            'total_count',
            this._getSearchProductsFieldsItems()
        ];
    }

    _getSearchProductsFieldsItems() {
        return new Field('items').addFieldList([
            'sku',
            'name',
            'url_key',
            this._getProductThumbnailField()
        ]);
    }

    _getProductThumbnailField() {
        return new Field('thumbnail').addFieldList([
            'path',
            'url'
        ]);
    }

    // Categories

    _getSearchCategoriesField() {
        return new Field('categories')
            .addFieldList(this._getSearchCategoriesFields());
    }

    _getSearchCategoriesFields() {
        return [
            'total_count',
            this._getSearchCategoriesFieldsItems()
        ];
    }

    _getSearchCategoriesFieldsItems() {
        return new Field('items').addFieldList(['name', 'url_path']);
    }

    // Pages

    _getSearchPagesField() {
        return new Field('pages')
            .addFieldList(this._getSearchPagesFields());
    }

    _getSearchPagesFields() {
        return [
            'total_count',
            this._getSearchPagesFieldsItems()
        ];
    }

    _getSearchPagesFieldsItems() {
        return new Field('items').addFieldList(['title', 'identifier']);
    }
}

export default new SearchQuery();
